export const TABS_OFFERS = {
	DRUNI: 'Druni',
	PRIMOR: 'Primor'
}